import { TreeItem } from '@mui/lab';
import ListTreeView from './ListTreeView';
import Confirmation from "../../../Components/Modal/Confirmation";
import { useState } from 'react';

const RenderTreeView = (props) => {
    //State    
    const [confirmModal, setConfirmModal] = useState(false);

    const menuOptions = [
        { text: 'Set Enumeration', value: 'add' },
        { text: 'Add Node/Branch', value: 'addnode' },
        { text: 'Add Leaf', value: 'addcls' },
        { text: 'Edit Enumeration', value: 'edit' },
        { text: 'Delete', value: 'del' },
    ]

    const onPressButton = (selectedAction, currentSection) => {
        props.removeNode(currentSection, selectedAction);
        setConfirmModal(false);
    }

    const getMenuSelection = (selectedAction, currentSection) => {
        if (selectedAction.value == 'addnode') {
            props.addNodeBranch(currentSection, selectedAction);
        } else if (selectedAction.value == 'add' || selectedAction.value == 'addcls') {
            props.createNode(currentSection, selectedAction);
        } else if (selectedAction.value == 'edit') {
            props.editNode(currentSection, selectedAction);
        } else if (selectedAction.value == 'del') {
            props.removeNode(currentSection, selectedAction);
        }
    }

    return (
        <>
            <TreeItem
                key={props.data.id}
                nodeId={props.data.id}
                sx={{color: "primary.main", borderRadius:10}}
                label={<ListTreeView
                    nodes={props.data}
                    mode={props.mode}
                    pressButton={() => { setConfirmModal(true) }}
                    modelOptions={menuOptions}
                    modelTitle={'Select action'}
                    changeMenuItem={(selectedObj) => { getMenuSelection(selectedObj, props.data) }}
                        
                />
                }
            >
                {
                    (props.data.children && props.data.children.length > 0) &&
                    props.data.children.map((node) => {
                        return (
                            <RenderTreeView
                                data={node}
                                mode={props.mode}
                                addNodeBranch={props.addNodeBranch}
                                createNode={props.createNode}
                                editNode={props.editNode}
                                removeNode={props.removeNode}
                            />)
                    })
                }
            </TreeItem>
            <Confirmation
                image="assign"
                primaryText="Are you sure you want to delete this item?"                
                visible={confirmModal}
                positiveClick={() => { onPressButton('del', props.data)}}
                negativeClick={() => { setConfirmModal(false)}}                
                persistent={true}
            ></Confirmation>
        </>
    );

}
export default RenderTreeView;